export default "__VITE_ASSET__D5GXEvb3__"